import { useAuthContext } from "../context/auth";

/**
 * 쿨다운 다음에 '오늘의 TOP 5' 를 넣을지. 실시간 심박 화면(WorkoutType1)과 같은 조건이다 —
 * 코인 운영 + 운영설정 '심박수' 가 켜진 지점에서 수업을 골라 시작했을 때만.
 * 베이직 프로그램은 실시간 심박 화면이 없어 넣지 않는다.
 */
function useShowClassRanking() {
  const { isCoinEnabled, isHeartRateEnabled, classId, basicProgram } =
    useAuthContext();
  return (
    isCoinEnabled &&
    isHeartRateEnabled &&
    classId !== undefined &&
    basicProgram?.programType !== "BASIC"
  );
}

export default useShowClassRanking;
